export enum PacErrorsEnum {
  E001 = "PAC or STAC does not match the mobile number supplied.",
  F001 = "PAC or STAC matches the mobile number but has expired.",
  F002 = "PAC or STAC matches the MPN but has already been used.",
  F004 = "The PAC entered has been created incorrectly (Secondary MSISDN). Please contact the current provider to create a valid PAC.",
  ERROR_UNKNOWN = "An error occurred when trying to validate the PAC. Please try again.",
  ERROR_NO_RESPONSE_FROM_MP = "An error occurred when trying to validate the PAC. Please try again.",
}
